import React, { useEffect, useState } from 'react';
import styles from './testEnd.module.scss';
import classNames from 'classnames/bind';
import { CommonCard } from '../../common/card';
import { CommonButton } from '../../common/button';
import NoSsr from '@common/noSsr';
import { InterviewVideoPlayer } from '../../common/video/player/interviewVideoPlayer';
import { InterviewPracticeStepCode } from '@domain/constant/interviewPracticeStep';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import { shallow } from 'zustand/shallow';
import Button from '@components/common/button';

const cx = classNames.bind(styles);

export const TestEnd = () => {
  const recorderService = useInterviewPracticeStore((state) => state.recorderService, shallow);
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const setStep = useInterviewPracticeStore((state) => state.practiceStepInfo.setStep, shallow);
  const [enabled, setEnabled] = useState(false);

  const handleClickReStart = async () => {
    setEnabled(false);
    setTimeout(() => setStep(InterviewPracticeStepCode.TEST_PROGRESS), 500);
  };

  const handleClickConfirm = () => {
    setEnabled(false);
    setTimeout(() => toNextStep(), 500);
  };

  useEffect(() => {
    setTimeout(() => setEnabled(true), 100);
  }, []);

  return (
    <CommonCard className={cx('card', { enabled })}>
      <div className={cx('header')}>
        <div className={cx('title')}>환경상태 체크가 완료되었습니다</div>
        <div className={cx('guide')}>
          녹화된 영상이 잘 나오는지 확인해 주세요. <br />
          이상이 있다면 ‘다시하기’를 눌러 다시 녹화해주세요.
        </div>
      </div>
      <div className={cx('webcamContainer')}>
        <NoSsr>
          <InterviewVideoPlayer className={cx('webcam')} source={recorderService.lastRecordingData} />
        </NoSsr>
      </div>
      <div className={cx('footer')}>
        <Button theme="secondary" onClick={handleClickReStart} styles={{ width: 168, height: 48 }}>
          다시하기
        </Button>
        <Button onClick={handleClickConfirm} styles={{ width: 168, height: 48 }}>
          확인
        </Button>
      </div>
    </CommonCard>
  );
};
